const initialState = {
  loading: false,
  rpBalance: 0,
  tdgBalance: 0,
  myStakingBalance: 0,
  totalStaked: 0,
  rewardTotal: 0,
  rewardTime: 0,
  rewardBalance: 0,
  weeklyEmmissions: 0,
  dailyEmmissions: 0,
  claimTokens: 0,
  totalSupplyRPD: 0,
  totalSupplySH: 0,
  totalSupplyCS: 0,
  totalSupplyJB: 0,
  totalSupplyMB: 0,
  allTokens: [],
  rpTokens: [],
  shTokens: [],
  csTokens: [],
  jbTokens: [],
  mbTokens: [],
  stakedTokens: [],
  error: false,
  errorMsg: "",
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHECK_DATA_REQUEST":
      return {
        ...state,
        rpBalance: 0,
        tdgBalance: 0,
        myStakingBalance: 0,
        totalStaked: 0,
        rewardTotal: 0,
        rewardTime: 0,
        rewardBalance: 0,
        weeklyEmmissions: 0,
        dailyEmmissions: 0,
        claimTokens: 0,
        totalSupplyRPD: 0,
        totalSupplySH: 0,
        totalSupplyCS: 0,
        totalSupplyJB: 0,
        totalSupplyMB: 0,
        allTokens: [],
        rpTokens: [],
        shTokens: [],
        csTokens: [],
        jbTokens: [],
        mbTokens: [],
        stakedTokens: [],
        loading: true,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_SUCCESS":
      return {
        ...state,
        loading: false,
        rpBalance: action.payload.rpBalance,
        tdgBalance: action.payload.tdgBalance,
        myStakingBalance: action.payload.myStakingBalance,
        totalStaked: action.payload.totalStaked,
        rewardTotal: action.payload.rewardTotal,
        rewardTime: action.payload.rewardTime,
        rewardBalance: action.payload.rewardBalance,
        weeklyEmmissions: action.payload.weeklyEmmissions,
        dailyEmmissions: action.payload.dailyEmmissions,
        claimTokens: action.payload.claimTokens,
        totalSupplyRPD: action.payload.totalSupplyRPD,
        totalSupplySH: action.payload.totalSupplySH,
        totalSupplyCS: action.payload.totalSupplyCS,
        totalSupplyJB: action.payload.totalSupplyJB,
        totalSupplyMB: action.payload.totalSupplyMB,
        allTokens: action.payload.allTokens,
        rpTokens: action.payload.rpTokens,
        shTokens: action.payload.shTokens,
        csTokens: action.payload.csTokens,
        jbTokens: action.payload.jbTokens,
        mbTokens: action.payload.mbTokens,
        stakedTokens: action.payload.stakedTokens,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_FAILED":
      return {
        ...initialState,
        rpBalance: 0,
        tdgBalance: 0,
        myStakingBalance: 0,
        totalStaked: 0,
        rewardTotal: 0,
        rewardTime: 0,
        rewardBalance: 0,
        weeklyEmmissions: 0,
        dailyEmmissions: 0,
        claimTokens: 0,
        totalSupplyRPD: 0,
        totalSupplySH: 0,
        totalSupplyCS: 0,
        totalSupplyJB: 0,
        totalSupplyMB: 0,
        allTokens: [],
        rpTokens: [],
        shTokens: [],
        csTokens: [],
        jbTokens: [],
        mbTokens: [],
        stakedTokens: [],
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default dataReducer;
